import {
  HEX_292D38,
  HEX_364353,
  HEX_646A7E,
  HEX_CED7E2,
  HEX_DCDFE6,
  HEX_FFFFFF,
} from '@tanium/colors';
import { Background4, defineColor } from '@tanium/react-theme-definition';

export const PageFill = Background4;
export const HeaderBodyDivider = defineColor([HEX_CED7E2, HEX_364353]);
export const HeaderText = defineColor([HEX_292D38, HEX_FFFFFF]);
export const DesriptionText = defineColor([HEX_646A7E, HEX_DCDFE6]);
